// extracted by mini-css-extract-plugin
export default {"loader":"ayVvz6ocUgmS1wxwsCdsEw==","path":"_6I-mJQZ6IzfWH5oi0ThvGw=="};